import React, { useState } from 'react';
import classNames from 'classnames';
import DeviceChartYAxisTitle from './DeviceChartYAxisTitle';
import styles from './DeviceChartYAxis.module.css';

function DeviceChartYAxis({ position, datasets, scales, editable }) {
  const [tooltipId, setTooltipId] = useState(null);
  const [editorId, setEditorId] = useState(null);

  const showTooltip = (axisId) => {
    setTooltipId(axisId);
  };

  const hideTooltip = () => {
    setTooltipId(null);
  };

  const showEditor = (axisId) => {
    setEditorId(axisId);
  };
  const hideEditor = () => {
    setEditorId(null);
  };

  return (
    <div
      className={classNames(styles.root, {
        [styles.editable]: editable,
        [styles.left]: position === 'left',
        [styles.right]: position === 'right'
      })}
      onMouseLeave={editable ? hideTooltip : undefined}
    >
      {Object.entries(scales)
        .filter(([_, scale]) => scale.position === position)
        .map(([axisId, scale]) => (
          <DeviceChartYAxisTitle
            key={axisId}
            axisId={axisId}
            datasets={datasets}
            position={position}
            title={scale.title?.text}
            editable={editable}
            tooltip={tooltipId === axisId}
            editor={editorId === axisId}
            onClick={editable ? showEditor : undefined}
            onHover={editable ? showTooltip : undefined}
            onClose={editable ? hideEditor : undefined}
          />
        ))}
    </div>
  );
}

export default DeviceChartYAxis;
